import { beeXLogger } from '../helpers/logger';
import {
  parseResponseBody,
  prepareBody,
  requestSocketPromiseWithTimeout,
} from './query';
import * as SERVICE from '../constants/service.types';

export const startPlaybackCamera = async (input) => {
  const isTranscodeRequest = input?.functions === 'transcode_h264';
  const timeout = isTranscodeRequest ? 20000 : 10000;

  beeXLogger.debug(
    '🚀 ~ startPlaybackCamera ~ prepareBody(input):',
    prepareBody(input),
  );
  const response = await requestSocketPromiseWithTimeout(
    {
      body: prepareBody(input),
      appServiceType: SERVICE.START_PLAYBACK_CAMERA,
    },
    { timeout },
  );
  beeXLogger.debug(
    'response:startPlaybackCamera ',
    parseResponseBody(response),
  );

  return parseResponseBody(response);
};

export const getThumbnailPlaybackByTime = async (input) => {
  beeXLogger.debug('🚀 ~ getThumbnailPlaybackByTime ~ input:', input);
  const response = await requestSocketPromiseWithTimeout(
    {
      appServiceType: SERVICE.THUMBNAIL_PLAYBACK_CAMERA,
      body: prepareBody(input),
    },
    {
      timeout: 10000,
    },
  );

  beeXLogger.debug(
    '🚀 ~ getThumbnailPlaybackByTime ~ parseResponseBody(response):',
    parseResponseBody(response),
  );
  return parseResponseBody(response);
};

export const getPlaybackTimesOnCloud = async (input) => {
  beeXLogger.debug('🚀 ~ getPlaybackTimesOnCloud ~ input:', input);
  const response = await requestSocketPromiseWithTimeout({
    appServiceType: SERVICE.LIST_PLAYBACK_ON_CLOUD,
    body: prepareBody(input),
  });

  beeXLogger.debug(
    '🚀 ~ getPlaybackTimesOnCloud ~ parseResponseBody(response):',
    parseResponseBody(response),
  );
  return parseResponseBody(response);
};

export const getPlaybackTimesLocal = async (input) => {
  /**
   *
   * @param {
   * serial,
   * namespace
   * fromTime
   * toTime
   * => format: YYYY-MM-DD HH:mm:ss
   * } input
   * @returns
   */
  beeXLogger.debug('🚀 ~ getPlaybackTimesLocal ~ input:', input);
  const response = await requestSocketPromiseWithTimeout(
    {
      appServiceType: SERVICE.LIST_PLAYBACK_ON_DEVICE,
      body: prepareBody(input),
    },
    { timeout: 10000 },
  );
  beeXLogger.debug(
    '🚀 ~ getPlaybackTimesLocal ~ parseResponseBody(response):',
    parseResponseBody(response),
  );

  return parseResponseBody(response);
};

export const downloadPlaybackOnDevice = async (input) => {
  console.log('🚀 ~ downloadPlaybackOnDevice ~ input:', input);
  const response = await requestSocketPromiseWithTimeout(
    {
      appServiceType: SERVICE.DOWNLOAD_PLAYBACK_ON_DEVICE,
      body: prepareBody(input),
    },
    {
      timeout: 10000,
    },
  );

  console.log(
    '🚀 ~ downloadPlaybackOnDevice ~ parseResponseBody(response):',
    parseResponseBody(response),
  );
  return parseResponseBody(response);
};

export const getLinkStorageFileByTime = async (input, timeout = 10000) => {
  beeXLogger.debug('GENERATE_LINK_STORAGE_FILE_BY_TIME - input: ', input);
  const response = await requestSocketPromiseWithTimeout(
    {
      appServiceType: SERVICE.GENERATE_LINK_STORAGE_FILE_BY_TIME,
      body: prepareBody(input),
    },
    {
      timeout,
    },
  );

  beeXLogger.debug(
    'GENERATE_LINK_STORAGE_FILE_BY_TIME - response ',
    parseResponseBody(response),
  );
  return parseResponseBody(response);
};
